export const WELCOME_MODAL_OPEN = 'WELCOME_MODAL_OPEN';
export const WELCOME_MODAL_CLOSE = 'WELCOME_MODAL_CLOSE';

export function welcomeModalOpen() {
  return {
    type: WELCOME_MODAL_OPEN
  };
}

export function welcomeModalClose() {
  return {
    type: WELCOME_MODAL_CLOSE
  };
}